import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/qr/$qrLookupID/gated/$pamID/")({
  beforeLoad: async ({ params }) => {
    throw redirect({
      to: "/qr/$qrLookupID/gated/$pamID/look-up",
      params,
      search: { redirectFrom: Route.id },
    })
  },
})
